import React from 'react';
import RenderBar from './RenderBar';
import useBackgroundRuns from './useBackgroundRuns';
import { usePresenters } from '../scanExportStore';

// Session-level runs (Scan export, Export run) shown from the tabs that have no RenderBar of their own
// (Settings, Performance, Localize). Where a bar or the run's own tab already shows it (a presenter is
// registered) the dock stays hidden.
export default function ScanExportDock() {
  const { running, finished } = useBackgroundRuns();
  const presenters = usePresenters();
  if (presenters > 0 || (!running && !finished)) return null;
  return (
    <RenderBar fixed scanDock
      running={running}
      confirmation={!running && finished ? <>{finished.text} <button type="button" className="rbar-dismiss" onClick={finished.dismiss}>Dismiss</button></> : null} />
  );
}
